import { render, staticRenderFns } from "./ONumberField.vue?vue&type=template&id=27e8dc9d&scoped=true&"
import script from "./ONumberField.vue?vue&type=script&lang=js&"
export * from "./ONumberField.vue?vue&type=script&lang=js&"
import style0 from "./ONumberField.vue?vue&type=style&index=0&id=27e8dc9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e8dc9d",
  null
  
)

export default component.exports